import styled from '@emotion/styled';
import { FocusTrap } from 'focus-trap-react';
import { FC, PropsWithChildren } from 'react';

import Card from 'app/components/v2/components/Card';
import ClickAwayListener from 'app/components/v2/components/EventListeners/ClickAwayListener';
import KeyCodeListener from 'app/components/v2/components/EventListeners/KeyCodeListener';
import { EvtKeys } from 'app/types';

// Local Typings
interface Props extends AbsoluteDivProps {
  isOpen: boolean;
  onClose: () => void;
}
interface AbsoluteDivProps {
  width?: number | string;
}

// Local Variables
const AbsoluteDiv = styled.div<AbsoluteDivProps>(props => ({
  maxWidth: '100vw',
  position: 'absolute',
  right: 0,
  top: 0,
  width: props.width ?? 'auto',
}));

// Component Definition
const Menu: FC<PropsWithChildren<Props>> = ({
  children,
  isOpen,
  onClose,
  width,
}) => {
  return isOpen
    ? (
      <ClickAwayListener onClickOutside={onClose}>
        <div>
          <FocusTrap
            focusTrapOptions={{
              tabbableOptions: {
                displayCheck: 'legacy-full',
              },
            }}
          >
            {/* focus trap requires a single child that accepts a ref */}
            <div>
              <KeyCodeListener
                keyCodeActions={[
                  {
                    action: onClose,
                    key: EvtKeys.Esc,
                  },
                ]}
              >
                <AbsoluteDiv width={width}>
                  <Card
                    fullWidth
                    withBoxShadow
                  >
                    {children}
                  </Card>
                </AbsoluteDiv>
              </KeyCodeListener>
            </div>
          </FocusTrap>
        </div>
      </ClickAwayListener>
    )
    : null;
};

export default Menu;
